// @flow

import { ChangeEvent, useContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "../../routes/routesconfig";
import { Schema } from "../../types/Schema";
import { ApiContext } from "../../context/KeaAPI/newApi";

export const AddSchemaComponent = (): any => {
  const navigate = useNavigate();
  const { schemaApi } = useContext(ApiContext);
  const { t } = useTranslation();
  const [schemaCreated, setSchemaCreating] = useState(false);
  const [newSchema, setNewSchema] = useState({
    name: "",
    description: "",
    public: false,
  });

  const [dataLoaded, setDataLoaded] = useState(false);

  // The data is loaded async and the page is only rendered once all data is loaded.
  useEffect(() => {
    Promise.all([schemaApi.getAll()]).then(() => {
      setDataLoaded(true);
    });
  }, []);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNewSchema({
      ...newSchema,
      [event.target.name]: event.target.value,
    });
  };

  const handleCheckboxChange = (event: any) => {
    setNewSchema({ ...newSchema, [event.target.name]: event.target.checked });
  };

  const createSchema = async () => {
    if (schemaCreated) {
      alert(t("alreadyCreatingSchema"));
      return;
    } else if ([newSchema.name, newSchema.description].some((field) => field.trim() === "")) {
      alert(t("fillAllFields"));
      return;
    }

    setSchemaCreating(true);
    let rawNewSchema: Schema = {
      name: newSchema.name,
      description: newSchema.description,
      publicSchema: newSchema.public,
      createdAt: "",
      updatedAt: "",
      id: -1,
    };
    await schemaApi.create(rawNewSchema);
    navigate(routes.schematreeview); // change to edit-schema component
  };

  return !dataLoaded ? (
    <div>Loading...</div>
  ) : (
    <div className="container mt-6">
      <div className="section">
        <div className="columns is-centered">
          <div className="column is-three-quarters">
            <div className="box">
              <h4 className="title is-4">{t("createRootSchema")}</h4>
              <div className="field">
                <label className="label">{t("name")}</label>
                <input
                  className="input"
                  type="text"
                  name="name"
                  value={newSchema.name ?? ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label">{t("description")}</label>
                <input
                  className="input"
                  type="text"
                  name="description"
                  value={newSchema.description ?? ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label">{t("schemaispublic")}</label>
                <input name="public" type="checkbox" checked={newSchema.public} onChange={handleCheckboxChange} />
              </div>
              <div className="columns mt-4">
                <button
                  className="button is-danger"
                  onClick={() => {
                    navigate(routes.schematreeview);
                  }}
                >
                  {t("cancel")}
                </button>
                <button className="button is-normal is-success" onClick={createSchema}>
                  {t("create")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
